import { GridCellProps } from '@progress/kendo-react-grid';
import { validateNumber } from 'src/assets/static/view_checkbook/useCheckbookPeriodColumns';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';

const BudgetAmountDollarCell = (props: GridCellProps) => {
  const { dataItem, field = '' } = props;
  const value = dataItem[field];
  const { displayValue } = useGridCellDisplayValue(props);

  return (
    <GridCellBase
      {...props}
      title={displayValue}
      rowSelectionEnabled
      style={{
        ...validateNumber(field, dataItem),
        textAlign: 'right',
      }}
      className={` ${value === null ? 'text-left' : 'text-right'}`}
    >
      <span>{displayValue}</span>
    </GridCellBase>
  );
};

export default BudgetAmountDollarCell;
